
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';

import Iframe from './Iframe';

import ExternalConfiguration from './external-configuration';

import './index.css';

function App( props) {
  return (
    <BrowserRouter>
      <Route path={`${ExternalConfiguration.BasePath}/:iframeId`} component={Iframe}/>
    </BrowserRouter>
  );
}

ReactDOM.render( <React.StrictMode> <App /> </React.StrictMode>, document.getElementById('root') );
